import { axios, Response } from '../index'

const deleteTherapistById = (therapistId: string): Response<null> => {
  return axios.delete(`/v1/therapists/${therapistId}`)
}

export default deleteTherapistById
